import { Box, Typography } from "@mui/material"
import { DataGrid } from "@mui/x-data-grid"
import { v4 as uuidv4 } from 'uuid'

export const FormattedDataGrid = ({columns, rows, headerText}) =>{

    let idFound = false;

    columns.forEach((column) => {
        if(column.field === "id"){
            idFound = true;
        }
    })


    if(idFound){
        return(
                    <Box sx={{
             '& .wsu-theme-header': {
                backgroundColor: 'rgba(166, 15, 45, 1)',
                color: 'white'
                }
            }}>
                <DataGrid
                rows={rows}
                columns={columns}
                getRowHeight={() => "auto"}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 10,
                        },
                    },
                }}
                pageSizeOptions={[5,10,20]}
                sx={{
                    '& .MuiDataGrid-columnHeader .MuiSvgIcon-root': {
                        color: 'white', // Replace with your desired color
                     },
                }}
                />
            </Box>
        )
    }else{
            return(
                    <Box sx={{
             '& .wsu-theme-header': {
                backgroundColor: 'rgba(166, 15, 45, 1)',
                color: 'white'
                }
            }}>
                <Typography align="center">{headerText}</Typography>
                <hr />
                <DataGrid
                rows={rows}
                columns={columns}
                getRowHeight={() => "auto"}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 10,
                        },
                    },
                }}
                getRowId={() => uuidv4()}
                pageSizeOptions={[5,10,20]}
                sx={{
                    '& .MuiDataGrid-columnHeader .MuiSvgIcon-root': {
                        color: 'white', // Replace with your desired color
                     },
                }}
                />
            </Box>
        )
    }
    
}